import { gql } from '@apollo/client/core'
import { query, mutate } from '@/services/graphql/client'
import { entityRegistry } from '@/config/entityRegistry'
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 

// export const createEntity = async (type, formData) => {
//   const input = buildGraphQLInput(type, formData)
//   const variables = { record: input }
//   await mutate(CREATE_MUTATION_MAP[type], variables)
// }

// export async function removeOneOfTheType(type, _id) {
//   const singular = type === 'companies' ? 'company' : type?.endsWith('s') ? type.slice(0, -1) : type
//   const capitalised = singular.charAt(0).toUpperCase() + singular.slice(1)
//   const documentNode = gql`
//     mutation Remove${capitalised}($_id: MongoID!) {
//       ${singular}RemoveOne(filter: { _id: $_id }) {
//         recordId
//       }
//     }
//   `
//   return await mutate(documentNode, { _id })
// }

export async function checkCompanySSOEnabled(path) {
const documentNode = gql`
    query CompanyByFields($path: String!){
        getLogoUrl(path: $path)
    }
  `
  const { data } = await query(documentNode, { path })
  return  data['getLogoUrl']
}

export async function getCurrentUser() {
const documentNode = gql`
    query GetCurrentUser{
        getCurrentUser
    }
  `
  const { data } = await query(documentNode)
  return  data['getCurrentUser']
}


export async function fetchAllSummaries(){
  const queryBody = Object.entries(entityRegistry)
        .map(([type, config]) => {
          if(type === "entityConfigs") return 
          return `
            ${type}: ${config.summaryField} {
              ${config.summarySelection}
            }
          `
        })
        .join('\n')

    const combinedQuery = gql`
      query AllSummaries {
        ${queryBody}
      }
    `

    const { data } = await query(combinedQuery)

    return data
}

export async function resetPassword(password, email = null, token = null){
  const documentNode = gql`
    mutation ResetPassword($email: String, $password: String, $token: String) {
      resetPassword(email:$email, password: $password, token: $token)
    }
  `
  return await mutate(documentNode, {email, password, token})
}

export async function generateAPIKey(){
  sendLog("info", "generate_api_key_is_requested")
  const generateAPIKey = gql`
    mutation GenerateAPIKey {
      generateAPIKey
    }
  `
  return await mutate(generateAPIKey)
}

export async function updateEntityConfig({id, mfa, subsystemAccess}){
  sendLog("debug", "update_entity_config", {id, mfa, subsystemAccess})
  const updateEntityConfigGQL = gql`
    mutation entityconfigUpdateById($id: MongoID!, $mfa: Boolean, $subsystemAccess: [EnumEntityConfigSubsystemAccess] ) {
      entityconfigUpdateById(_id: $id, record: { mfa: $mfa, subsystemAccess: $subsystemAccess }){recordId}
    }
  `
  return await mutate(updateEntityConfigGQL, {id, mfa, subsystemAccess})
}

export async function createEntityConfig(record){
  sendLog("debug", "create_entity_config", record)
  const {id, ...rest} = record
  const createEntityConfigGQL = gql`
    mutation entityconfigCreateOne($record: CreateOneEntityConfigInput! ) {
      entityconfigCreateOne(record: $record) { recordId record {_id }}
    }
  `
  return await mutate(createEntityConfigGQL, { record: { ...rest, subsystemAccess: [...(rest.subsystemAccess || [])] } })
}

export async function forgetPassword(email){
  const documentNode = gql`
    mutation ForgetPassword($email: String) {
      forgetPassword(email:$email)
    }
  `
  return await mutate(documentNode, {email})
}
